import Axios from 'axios'
import {
	IConfirmTreasuryItemProductParams,
	IGetTreasuryProductDataParams,
	ILoadingTreasuryItemParams,
	IUpdateTreasuryProductDataParams
} from 'models/IndividualTreasuryItem'
const urlApi = '/carga_item_tes'

export const loadingTreasuryItemApi = async (
	params: ILoadingTreasuryItemParams
) => {
	const response = await Axios.post(urlApi, params)
	return response.data
}

export const getTreasuryProductDataApi = async (
	params: IGetTreasuryProductDataParams
) => {
	const response = await Axios.get(`${urlApi}/modificar`, { params })
	return response.data
}

export const updateTreasuryProductDataApi = async (
	params: IUpdateTreasuryProductDataParams
) => {
	const response = await Axios.post(`${urlApi}/modificar/confirmar`, params)
	return response.data
}

export const confirmTreasuryItemProductApi = async (
	params: IConfirmTreasuryItemProductParams
) => {
	const response = await Axios.post(`${urlApi}/confirmar`, params)
	return response.data
}
